<template>
  <div class="settings-page">
    <PageHeader header="Profile" icon="mdi-account" />
    <PageContent>
      <div class="settings-detail">
        <!-- User profile card -->
        <div class="profile-card">
          <v-avatar color="primary" size="64" class="profile-avatar">
            <span class="white--text text-h5">{{ getInitials() }}</span>
          </v-avatar>
          <div class="profile-info">
            <h3>{{ UserInfoStore.name }}</h3>
            <span class="profile-email">{{ UserInfoStore.email }}</span>
            <v-chip v-if="UserInfoStore.admin" x-small color="primary" text-color="white" class="mt-1">Admin</v-chip>
          </div>
        </div>

        <v-list class="settings-list" dense>
          <v-subheader>ORGANIZATION</v-subheader>
          <v-list-item>
            <v-list-item-icon><v-icon>mdi-office-building-outline</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ OrgInfoStore.name }}</v-list-item-title>
              <v-list-item-subtitle>Organization</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list class="settings-list" dense>
          <v-list-item @click="signout" class="sign-out-item">
            <v-list-item-icon><v-icon color="error">mdi-logout-variant</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="error--text">Sign Out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </PageContent>
  </div>
</template>

<script>
import PageContent from "@/components/pages/PageContent.vue";
import PageHeader from "@/components/pages/PageHeader.vue";

import { OrgInfoStore } from "@/stores/OrgInfoStore.js";
import { UserInfoStore } from "@/stores/UserInfoStore.js";

import AuthUtil from "@/util/AuthUtil";

export default {
  name: "SettingsPage",
  components: {
    PageContent,
    PageHeader,
  },
  data() {
    return {
      OrgInfoStore,
      UserInfoStore,
    };
  },
  methods: {
    signout: function () {
      AuthUtil.logout();
    },
    getInitials: function () {
      if (UserInfoStore.firstName && UserInfoStore.lastName) {
        return UserInfoStore.firstName[0] + UserInfoStore.lastName[0];
      }
      return "";
    },
  },
  mounted() {},
  props: {},
};
</script>

<style scoped>
.settings-page {
  height: 100%;
}

.profile-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.profile-info h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 2px;
}

.profile-email {
  font-size: 14px;
  color: #78909C;
}

.settings-list {
  padding: 8px 0;
}

.sign-out-item {
  cursor: pointer;
}
</style>
